import type { Visualizer } from './types';
import { clearBg, drawHud } from './types';

export const waveViz: Visualizer = {
  id: 'wave',
  label: '3D Wave',
  draw(frame) {
    const { ctx, w, h, wave, bands, t } = frame;
    clearBg(ctx, w, h, 0.28);
    const layers = 5;
    for (let L = 0; L < layers; L++) {
      const yMid = h * (0.35 + L * 0.1);
      const amp = h * (0.04 + bands.energy * 0.08) * (1 - L * 0.12);
      ctx.beginPath();
      for (let x = 0; x <= w; x += 3) {
        const i = Math.floor((x / w) * (wave.length - 1));
        const s = wave[i] || 0;
        const y =
          yMid +
          s * amp * 18 +
          Math.sin(x * 0.008 + t * (1.2 + L * 0.15) + L) * amp * (0.6 + bands.mids);
        if (x === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.strokeStyle = `hsla(${165 + L * 12 + bands.highs * 30}, 90%, ${55 + L * 5}%, ${0.35 + bands.energy * 0.35})`;
      ctx.lineWidth = 2 + bands.bass * 2;
      ctx.stroke();
    }
    // center punch
    if (bands.kick > 0.5) {
      ctx.fillStyle = `rgba(86,240,200,${0.04 + bands.kick * 0.06})`;
      ctx.fillRect(0, 0, w, h);
    }
    drawHud(frame);
  },
};
